import { render } from "./FeaturedPartners.vue?vue&type=template&id=ca553578&scoped=true"
import script from "./FeaturedPartners.vue?vue&type=script&lang=js"
export * from "./FeaturedPartners.vue?vue&type=script&lang=js"

import "./FeaturedPartners.vue?vue&type=style&index=0&id=ca553578&scoped=true&lang=scss"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-ca553578"]])

export default __exports__